"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    linkBaseStyle: function() {
        return linkBaseStyle;
    },
    Link: function() {
        return Link;
    }
});
var _components = require("../../../components");
var _utils = require("@chakra-ui/utils");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var linkBaseStyle = {
    width: "inherit",
    borderRadius: "0.25rem",
    _hover: {
        textDecoration: "none"
    }
};
var generateLink = function(colors) {
    return {
        color: colors.default,
        padding: 0,
        borderRadius: "0.25rem",
        _hover: {
            textDecoration: "none",
            color: colors.hover
        },
        _active: {
            color: colors.pressed
        },
        _focus: {
            boxShadow: "0 0 0 0.25rem var(--chakra-colors-".concat(colors.focus, ")"),
            color: colors.hover
        },
        _focusVisible: {
            boxShadow: "0 0 0 0.25rem var(--chakra-colors-".concat(colors.focus, ")"),
            color: colors.hover
        },
        _disabled: {
            color: colors.disabled,
            cursor: "not-allowed",
            boxShadow: "none"
        }
    };
};
var isButtonVariant = function(variant) {
    return !variant.startsWith("link");
};
var getButtonVariants = function() {
    return _components.buttonVariants.reduce(function(prev, variant) {
        return _object_spread_props(_object_spread({}, prev), _define_property({}, variant, function(params) {
            var variantValue = params.theme.components.Button.variants[variant];
            return (0, _utils.omit)(typeof variantValue === "function" ? variantValue(params) : variantValue, [
                "loading"
            ]);
        }));
    }, {});
};
var getSizes = function() {
    var sizes = {};
    _components.linkSizes.forEach(function(size) {
        sizes[size] = function(props) {
            return isButtonVariant(props.variant) ? (0, _utils.omit)(props.theme.components.Button.sizes[size](props), [
                "loading"
            ]) : _object_spread_props(_object_spread({}, props.theme.textStyles[({
                s: "text-body-meta-medium",
                m: "text-body-medium",
                l: "text-body-large-medium"
            })[size]]), {
                columnGap: "0.5rem"
            });
        };
    });
    return sizes;
};
var linkPrimary = generateLink({
    default: "text-link-primary-default",
    hover: "text-link-primary-hover",
    pressed: "text-link-primary-pressed",
    focus: "text-link-primary-hover",
    disabled: "text-link-primary-disabled"
});
var Link = {
    baseStyle: function(props) {
        var buttonBaseStyle = _object_spread_props(_object_spread({}, props.theme.components.Button.baseStyle), {
            display: "inline-flex",
            _hover: {
                textDecorationLine: "none"
            }
        });
        var linkDisplayStyles = !props.isInline ? {
            display: "inline-flex",
            alignItems: "center"
        } : {
            display: "inline"
        };
        return isButtonVariant(props.variant) ? buttonBaseStyle : _object_spread({}, linkBaseStyle, linkDisplayStyles);
    },
    sizes: getSizes(),
    variants: _object_spread({
        link: linkPrimary,
        "link-primary": linkPrimary,
        "link-light": generateLink({
            default: "text-link-light-default",
            hover: "text-link-light-hover",
            pressed: "text-link-light-pressed",
            focus: "text-link-light-hover",
            disabled: "text-link-light-disabled"
        }),
        "link-accent": generateLink({
            default: "text-link-accent-default",
            hover: "text-link-accent-hover",
            pressed: "text-link-accent-pressed",
            focus: "text-link-accent-hover",
            disabled: "text-link-accent-disabled"
        }),
        "link-secondary": generateLink({
            default: "text-link-secondary-default",
            hover: "text-link-secondary-hover",
            pressed: "text-link-secondary-pressed",
            focus: "text-link-secondary-hover",
            disabled: "text-link-secondary-disabled"
        }),
        "link-destroy": generateLink({
            default: "alert-error-default",
            hover: "alert-error-hover",
            pressed: "alert-error-pressed",
            focus: "alert-error-hover",
            disabled: "alert-error-disabled"
        })
    }, getButtonVariants()),
    defaultProps: {
        size: "l",
        variant: "link-primary"
    }
};
